import { Suspense, lazy } from 'react';
import { Link } from 'react-router';

import { useGetMy } from '../query/auth';
import LogoutButton from './logout-button';
import { Avatar, AvatarImage } from './ui/avatar';
import { Button } from './ui/button';
import { SidebarHeader } from './ui/sidebar';

const CircleUserRound = lazy(() =>
  import('lucide-react').then(mod => ({ default: mod.CircleUserRound })),
);
const Settings = lazy(() => import('lucide-react').then(mod => ({ default: mod.Settings })));

const AppSidebarHeader = () => {
  const { data: myInfo } = useGetMy();
  return (
    <SidebarHeader className="border-b border-white">
      <div className="flex flex-col gap-2 my-2">
        <div className="flex items-center gap-3">
          <Avatar className="h-10 w-10 bg-white">
            {myInfo?.data?.profileUrl ? (
              <AvatarImage src={myInfo?.data?.profileUrl} alt="profile" />
            ) : (
              <Suspense fallback={<div className="w-10 h-10" />}>
                <CircleUserRound width={40} height={40} strokeWidth={1} aria-hidden="true" />
              </Suspense>
            )}
          </Avatar>
          <div>
            <div className="font-semibold text-white">{myInfo?.data?.name}</div>
            <div className="text-sm text-white">{myInfo?.data?.school}</div>
          </div>
        </div>
        <div className="flex items-center justify-between gap-2">
          <Button
            variant="outline"
            size={'sm'}
            className="justify-start bg-transparent shadow flex-1"
            asChild
          >
            <Link to={'/my'}>
              <Suspense fallback={<div className="w-4 h-4" />}>
                <Settings />
              </Suspense>
              설정
            </Link>
          </Button>
          <LogoutButton />
        </div>
      </div>
    </SidebarHeader>
  );
};

export default AppSidebarHeader;
